import { Controller } from "react-hook-form";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FormInputProps } from "../types";

interface IProps {
  selectOptions: {
    display?: string;
    system?: string;
    code?: string;
    value?: string;
  }[];
  defaultValue?: any;
  readOnly?: boolean;
}

type TypeMergedInterfaces = FormInputProps & IProps;

export function FormSelectCompleted({
  name,
  control,
  label,
  required,
  readOnly,
  selectOptions,
  defaultValue,
}: TypeMergedInterfaces) {
  return (
    <FormControl
      variant="filled"
      sx={{
        "& .MuiFilledInput-root": { backgroundColor: "neutral100.main" },
      }}
      fullWidth
    >
      <InputLabel id="select-small-label">{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{
          required: required,
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <Select
              readOnly={readOnly}
              value={value?.value || defaultValue?.value || ""}
              label={label}
              onChange={(e) => {
                const selectedOption = selectOptions.find(
                  (option: any) => option.value === e.target.value
                );
                onChange(selectedOption);
              }}
              error={error !== undefined}
              fullWidth
            >
              {selectOptions.map((element: any, index: any) => {
                return (
                  <MenuItem key={index} value={element.value}>
                    {element.display}
                  </MenuItem>
                );
              })}
            </Select>
          );
        }}
      />
    </FormControl>
  );
}
